<div class="responsive-card gap-4">
  <div class="d-flex justify-content-between align-items-center">
    <div i18n class="responsive-card-title">Account Details</div>
    <div *ngIf="boardDirectedAccount" class="d-flex gap-2">
      <img
        [src]="'assets/icons/primary/Circle Info.svg'"
        alt="info icon"
        i18n-alt
        [style.width.rem]="1.03125"
        [style.height.rem]="1.03125" />
      <div i18n class="value">Board Directed Variable Benefit</div>
    </div>
  </div>
  <div class="d-flex gap-4 w-100">
    <div class="inner-card w-50">
      <div i18n class="label">Funding Effective Date*</div>
      <div class="value">{{ submission?.new?.effectiveDate | date : 'MMMM dd, yyyy' }}</div>
    </div>
    <div class="inner-card w-50">
      <div i18n class="label">Recurring Payment Changes Starting In</div>
      <div class="value">{{ submission?.new?.recurringPaymentStartDate | date : 'MMMM yyyy' }}</div>
    </div>
  </div>
  <div i18n class="info">*Actual effective dates are subject to variation of up to five weeks from the set date.</div>
</div>
